import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, serverDown } = useAuth();

  // Still checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#3B82F6] mx-auto"></div>
          <p className="text-[#94A3B8] mt-4" data-testid="auth-loading-text">
            {serverDown ? "Can't reach the server. Retrying…" : 'Loading...'}
          </p>
          {serverDown && (
            <p className="text-xs text-[#475569] mt-1">It may be restarting. You are still logged in.</p>
          )}
        </div>
      </div>
    );
  }

  // Not authenticated
  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
